<template>
	<div>
		
        <el-card class="box-card">
            <div style="display: flex;background: white">
                <div style="width: 50%;text-align: left;display: flex">
                    <el-button type="primary" size="mini" @click="deleteAll">{{$t('getapi[686]')}}</el-button>
                    <el-upload
                            class="upload-demo"
                            ref="upload"
                            :action="uploadurl"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :on-change="handleChange"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :file-list="fileList"
                            :limit="1"
							accept=".xlsx"
                            style="margin-left: 8px"
                    >
                        <el-button slot="trigger" size="mini" type="primary" :disabled="!btn.Import">{{$t('getapi[6507]')}}</el-button>
                    </el-upload>
                </div>
                <div style="width: 50%;text-align: right">
                    <el-button type="primary" size="mini" @click="save">{{$t('getapi[370]')}}</el-button>
                </div>
            </div>
        </el-card>

				<vxe-table :data="datajson"
				show-overflow
				ref='CloseSoTable'
				size="mini" :loading="loading"  :height="tableHeight" stripe border resizable>
					<vxe-table-column type="checkbox" align="center" width="60"></vxe-table-column>
					<vxe-table-column show-footer-overflow field="errormsg" :title="$t('getapi[357]')" width="150px"></vxe-table-column>
					<vxe-table-column show-footer-overflow field="requisition_no" :title="$t('getapi[1480]')" width="100"></vxe-table-column>
					<vxe-table-column show-footer-overflow field="pur_requisition_type" :title="$t('getapi[3628]')" width="100"></vxe-table-column>
					<vxe-table-column show-footer-overflow field="item_code" :title="$t('getapi[4910]')" width="100"></vxe-table-column>
					<vxe-table-column show-footer-overflow field="row_number" :title="$t('getapi[1425]')" align="right" width="100"></vxe-table-column>
					<vxe-table-column show-footer-overflow field="part_code" :title="$t('getapi[1513]')" width="120"></vxe-table-column>
					<vxe-table-column show-footer-overflow field="part_name" :title="$t('getapi[116]')" width="100"></vxe-table-column>
					<vxe-table-column show-footer-overflow field="part_version" :title="$t('getapi[149]')" width="100"></vxe-table-column>
					<vxe-table-column show-footer-overflow field="model" :title="$t('getapi[124]')" width="100"></vxe-table-column>
					<vxe-table-column show-footer-overflow field="specification" :title="$t('getapi[125]')" width="100"></vxe-table-column>
					<vxe-table-column show-footer-overflow field="check_std_code" :title="$t('getapi[186]')" width="100"></vxe-table-column>
					<vxe-table-column show-footer-overflow field="material_std_code" :title="$t('getapi[189]')" width="100"></vxe-table-column>
					<vxe-table-column field="plan_qty" :title="$t('getapi[1504]')" align="right" width="100">
						<template slot-scope="scope">
							{{scope.row.plan_qty | thousandth}}
						</template>
					</vxe-table-column>
					<vxe-table-column show-footer-overflow field="pur_measurementunit" :title="$t('getapi[3100]')" width="100"></vxe-table-column>
					<vxe-table-column field="expect_ship_date" :title="$t('getapi[1505]')" width="100">
						<template slot-scope="scope">
							{{scope.row.expect_ship_date | toDate}}
						</template>
					</vxe-table-column>
					<vxe-table-column show-footer-overflow field="inventory_qty" :title="$t('getapi[1506]')" align="right" width="100">
						<template slot-scope="scope">
							{{scope.row.inventory_qty | thousandth}}
						</template>
					</vxe-table-column>
					<vxe-table-column show-footer-overflow field="vender_code" :title="$t('getapi[1507]')" width="100"></vxe-table-column>
					<vxe-table-column field="already_pur_qty" :title="$t('getapi[1508]')" align="right" width="100">
						<template slot-scope="scope">
							{{scope.row.already_pur_qty | thousandth}}
						</template>
					</vxe-table-column>
					<vxe-table-column show-footer-overflow field="line_status" :title="$t('getapi[2954]')" width="100"></vxe-table-column>
				</vxe-table>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
import CommonHeader from '@/components/CommonHeader';
export default {
	name:'purschemeimport',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight- 165
        }
    },
	data() {
		return {
			fileList: [],
			itevisible:false,
			tabIndex:'0',
			ids: '',
			showloading: '',
			DbTbNames: '', //表名
			datajson: [],
			datajsonremark: [],
			datajsonliu: [],
			loading: false, // 主表加载状态
			uploadurl: '',
			uploadurlremark: '',
			uploadurlliu: '',
			drolist: [],
			drolistliu: [],
			drosele: 0,
			droseleliu: 0,
			total1: 0,
			btn:{
				//添加
				Add:true,
				//移除
				Remove:false,
				//导入
				Import:true
			},
			isShowDialog: false,
			title: '',//标题
			content: '',//内容
            scrollTop:0,
		};
	},
	created () {
		setTimeout(() => {
		this.datajsonliu = [];
		this.datajson = [];
		}, 1000)
	},
	beforeMount() {
		console.log('beforeMount');
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		let token = JSON.parse(that.userData).token;
		that.uploadurl = Common.Url + '/Pur/Requisition/PurPlanLineToUpFile?token=' + token;
		this.btnauthority();
	},
	mounted() {
		console.log('mounted');
		this.btnauthority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.CloseSoTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.CloseSoTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })

    },
	methods: {
		btnauthority() {
			let that = this;
		},
		deleteAll(){
			let that = this;
			let selectRecords = this.$refs.CloseSoTable.getCheckboxRecords();
			for(let i=selectRecords.length-1;i>=0;i--){
				let line = this.$refs.CloseSoTable.getRowIndex(selectRecords[i]);
				that.datajson.splice(line, 1);
			}
		},
		handleSelectionChange(val) {
			let that = this;
			that.selectIDData = '';
			for (let i = 0; i < val.length; i++) {
				that.selectIDData += val[i].Exclusively_Id + ',';
			}
			console.log(that.selectIDData);
		},

		handleChange(file, fileList) {
			let that = this;
			that.loading = true;
			console.log(file);
			if (file.response) {
				let response = file.response.Success;
				if (response == 0) {
					that.$message.error(file.response.Msg);
				} else {
                    that.datajson = file.response.DataContent;
				}
			}
				that.loading = false;
		},

		handleSuccess(res, file, fileList) {
			let that = this;
			console.log(res);
			let response = res.Success;
			if (response == 0) {
                that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
			} else {
				if(res.DataContent.length>0){
                    that.datajson = res.DataContent;
				}else{
					that.$message.warning(that.$t('getapi[8711]'));//Excel中无数据！
				}
				
			}
			that.fileList=[];
		},
		handleError(err, file, fileList) {
			let that = this;
			that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
		},
		handleRemove(file, fileList) {
			console.log(file, fileList);
		},
		handlePreview(file) {
			console.log("handlePreview"+file);
		},
		save() {
            let that = this;
            if(that.datajson.length==0){
                that.$message.warning(that.$t('getapi[8712]'));//'请添加导入数据！'
                return;
            }
            let parm = that.datajson
            that.$http.urlpost('/Pur/Requisition/PurPlanLineImportSave', parm, function (res) {
                if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    if(res.DataContent != null){
                        that.datajson = res.DataContent.dt
					}
				}
            });
		},
	}
};
</script>

<style lang="scss" scoped>
span.label-fade-enter {
	font-size: medium;
	margin-right: 20px;
}
</style>
<style>
  .el-message-box {
    width: 600px;
  }
</style>
